module.exports = __webpack_public_path__ + "static/media/bg-white-short.76e7ca9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg-white-short.jpg
// module id = 456
// module chunks = 6